/* eslint-disable no-undef */
"use strict";

import wixService from '../../utils/wixService';
import axios from 'axios';
import URLSearchParams from 'url-search-params';


let httpRequests = {
    instance: () => (wixService.Utils.getInstance()),
    compId: () => ( window.location.search.substr(1).indexOf("endpointType=settings") > -1 ? wixService.Utils.getOrigCompId() : wixService.Utils.getCompId()),
    originCompId: () => (wixService.Utils.getInstanceValue('originCompId')),
    originInstanceId: () => {
        const isExistOriginInstanceId = wixService.Utils.getInstanceValue('originInstanceId') ? '&originInstanceId=' + wixService.Utils.getInstanceValue('originInstanceId') : '';
        return isExistOriginInstanceId;
    },
    instanceId: () => {
    return   wixService.Utils.getInstanceValue('instanceId') ? '&instanceId=' + wixService.Utils.getInstanceValue('instanceId') : '';
 
    },
    getUrlQuery: function () {
        const params = new URLSearchParams(window.location.href); 
        const isExistOriginCompId = params.get('originCompId') ? '&originCompId=' + params.get('originCompId') : '';
        return '?instance=' + this.instance() + '&compId=' + this.compId() + isExistOriginCompId + this.originInstanceId() + this.instanceId() ;
    },
    post: function (url, params, cbs, cbf) {
        let urlQuery = this.getUrlQuery();
        return axios.post(url + urlQuery, params)
            .then(cbs).catch(cbf);
    },
    get: function (url, cbs, cbf) {
        let urlQuery = this.getUrlQuery();
        return axios.get(url + urlQuery)
            .then(cbs).catch(cbf);
    },
    delete: function (url, cbs, cbf) {
        let urlQuery = this.getUrlQuery(false);
        return axios.delete(url + urlQuery)
            .then(cbs).catch(cbf);
    }
};

//module.exports = httpRequests;
export default httpRequests;




// WEBPACK FOOTER //
// ./src/widget/api/httpRequests.js